import { InputText } from "primereact/inputtext";
import ErrorMessage from "./ErrorMessage";
import { useFormikContext, getIn } from "formik";
import CustomCheckbox from "./CustomCheckbox";
import { InputTextarea } from "primereact/inputtextarea";

export type CustomInputTextProps = {
  label: string;
  id: string;
  type?: "text" | "multiline" | "number" | "password" | "checkbox";
  labelIcon?: string;
  required?: boolean;
  onPressEnter?: () => void;
  [key: string]: any;
};

const CustomInputText = ({ label, id, type, required, ...props }: CustomInputTextProps) => {
  const formik = useFormikContext<any>();

  if (type === "checkbox") {
    return <CustomCheckbox label={label} id={id} {...props} />;
  }

  if (type === "multiline") {
    return (
      <div className="flex flex-column gap-2 mb-2">
        <label htmlFor={id}>
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
        <InputTextarea
          id={id}
          value={getIn(formik.values, id) ?? ""}
          onChange={(e) => formik.setFieldValue(id, e.target.value)}
          onBlur={formik.handleBlur}
          invalid={getIn(formik.touched, id) && !!getIn(formik.errors, id)}
          rows={5}
          autoResize={props.autoResize ?? false}
          {...props}
        />
        <ErrorMessage id={id} formik={formik} />
      </div>
    );
  }

  return (
    <div className="flex flex-column gap-2 mb-2">
      <label htmlFor={id}>
        {label}
        {props.labelIcon && <i className={`${props.labelIcon} text-yellow-500 ml-2`} />}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <InputText
        id={id}
        value={getIn(formik.values, id) ?? ""}
        onChange={(e) => formik.setFieldValue(id, e.target.value)}
        onBlur={formik.handleBlur}
        onKeyDown={(e) => e.key === "Enter" && (props.onPressEnter ? props.onPressEnter() : formik.handleSubmit())}
        invalid={getIn(formik.touched, id) && !!getIn(formik.errors, id)}
        {...props}
      />
      <ErrorMessage id={id} formik={formik} />
    </div>
  );
};

export default CustomInputText;
